import type { OnyxOptional } from '@onyx/angular';
import { TechnicalPointCategory } from '../../dashboard/fleet/common/enums/technical-point-category';
import { OrderPointCategory } from '../../dashboard/orders/common/enums/order-point-category';
import type { OrderPointEstimations } from '../../dashboard/orders/common/interfaces/order-point';
import type { OrderPointForm } from '../../dashboard/orders/order-form/order-points-form/order-point-form/order-point-form.component';
import type { RoutePoint } from '../services/route.service';
import type { RoutePointValue } from './route.helper';

export class RoutePointValueHelper {
  public static getValue(point: RoutePoint | RoutePointValue): RoutePointValue {
    if ('value' in point) return point.value;
    if ('point' in point && point.point) return point.point;
    if ('technicalPoint' in point) return point.technicalPoint;

    return point;
  }

  public static isOrderFormPoint(
    point: RoutePoint | RoutePointValue,
  ): point is OrderPointForm {
    return !('status' in point);
  }

  public static getEstimations(
    point: RoutePoint | RoutePointValue | null,
  ): OrderPointEstimations | null {
    if (!point) return null;

    if ('point' in point && point.point) return point.point.estimations;
    if ('technicalPoint' in point) return point.technicalPoint.estimations;

    return 'estimations' in point ? point.estimations : null;
  }

  public static getTimeWindows(value: OnyxOptional<RoutePointValue>) {
    if (!value) return null;

    switch (value.category) {
      case OrderPointCategory.LOADING:
      case OrderPointCategory.UNLOADING:
      case TechnicalPointCategory.DELEGATION:
        return 'timeWindows' in value ? value.timeWindows : null;

      default:
        return null;
    }
  }

  public static getTransitTimeWindows(value: OnyxOptional<RoutePointValue>) {
    if (value?.category !== OrderPointCategory.TRANSIT) return null;

    return value.timeWindow;
  }
}
